import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/components/Login'
import Home from '@/Home'
import Ekma from '@/components/Ekma'
import History from '@/components/History'
import RealTime from '@/components/RealTime'
Vue.use(Router);

export default new Router({
  routes: [
      {
          path: '/',
          name: 'Login',
          component: Login
      },{
          path: '/Home',
          name: 'Home',
          component: Home
      },{
          path: '/Home',
          component: Home,
          name: '实时数据',
          children: [
              {path: '/RealTime', name: 'RealTime', component: RealTime}
          ]
      },{
          path: '/Home',
          component: Home,
          name: '历史数据',
          children: [
              {path: '/History', name: 'History', component: History}
          ]
      },{
          path: '/Home',
          component: Home,
          name: 'EKMA',
          hidden:true,
          children: [
              {path: '/Ekma', name: 'Ekma',hidden:true, component: Ekma}
          ]
      },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js